import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&参考书部分
 *
 */


/**
 * 参考书查询：列表
 * @param {*} query
 */
export const consultList = (query) => {
  return request({
    url: `${prefix}/consult/list`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书查询
 * @param {*} query
 */
export const consultOne = (query) => {
  return request({
    url: `${prefix}/consult`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书查询 内容
 * @param {*} query
 */
export const consultContent = (query) => {
  return request({
    url: `${prefix}/consult/content`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书创建
 * @param {*} query
 */
export const consultCreate = (query) => {
  return request({
    url: `${prefix}/consult`,
    method: 'post',
    data: query
  })
}

/**
 * 参考书修改
 * @param {*} query
 */
export const consultUpdate = (query) => {
  return request({
    url: `${prefix}/consult`,
    method: 'put',
    data: query
  })
}

/**
 * 参考书修改状态
 * @param {*} query
 */
export const consultUpdateStatus = (query) => {
  return request({
    url: `${prefix}/consult/status`,
    method: 'put',
    data: query
  })
}

/**
 * 参考书删除
 * @param {*} query
 */
export const consultDestroy = (query) => {
  return request({
    url: `${prefix}/consult`,
    method: 'delete',
    data: query
  })
}

/**
 * 参考书删除 真
 * @param {*} query
 */
export const consultRemove = (query) => {
  return request({
    url: `${prefix}/consult/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 参考书恢复
 * @param {*} query
 */
export const consultRestore = (query) => {
  return request({
    url: `${prefix}/consult/restore`,
    method: 'post',
    data: query
  })
}

/**
 * 参考书克隆
 * @param {*} query
 */
export const consultClone = (query) => {
  return request({
    url: `${prefix}/consult/clone`,
    method: 'post',
    data: query
  })
}

/**
 * 参考书分类查询：列表
 * @param {*} query
 */
export const consultCategoryList = (query) => {
  return request({
    url: `${prefix}/consult/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书分类查询
 * @param {*} query
 */
export const consultCategoryOne = (query) => {
  return request({
    url: `${prefix}/consult/category`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书分类创建
 * @param {*} query
 */
export const consultCategoryCreate = (query) => {
  return request({
    url: `${prefix}/consult/category`,
    method: 'post',
    data: query
  })
}

/**
 * 参考书分类修改
 * @param {*} query
 */
export const consultCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/consult/category`,
    method: 'put',
    data: query
  })
}

/**
 * 参考书分类删除
 * @param {*} query
 */
export const consultCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/consult/category`,
    method: 'delete',
    data: query
  })
}

/**
 * 参考书题库查询：列表
 * @param {*} query
 */
export const consultExamList = (query) => {
  return request({
    url: `${prefix}/consult/exam/list`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书题库查询
 * @param {*} query
 */
export const consultExamOne = (query) => {
  return request({
    url: `${prefix}/consult/exam`,
    method: 'get',
    params: query
  })
}

/**
 * 参考书题库创建
 * @param {*} query
 */
export const consultExamCreate = (query) => {
  return request({
    url: `${prefix}/consult/exam`,
    method: 'post',
    data: query
  })
}

/**
 * 参考书题库修改
 * @param {*} query
 */
export const consultExamUpdate = (query) => {
  return request({
    url: `${prefix}/consult/exam`,
    method: 'put',
    data: query
  })
}

/**
 * 参考书题库状态修改
 * @param {*} query
 */
export const consultExamUpdateStatus = (query) => {
  return request({
    url: `${prefix}/consult/exam/status`,
    method: 'put',
    data: query
  })
}

/**
 * 参考书题库删除
 * @param {*} query
 */
export const consultExamDestroy = (query) => {
  return request({
    url: `${prefix}/consult/exam`,
    method: 'delete',
    data: query
  })
}
